import Header from "@/components/Header";
import Footer from "@/components/Footer";
import QuizGenerator from "@/components/QuizGenerator";
import { useAuth } from "@/contexts/AuthContext";
import HeroSection from "@/components/HeroSection";
import SavedQuizzes from "@/components/SavedQuizzes";
import AttemptHistory from "@/components/AttemptHistory";
import HowToUseSection from "@/components/HowToUseSection";

const Index = () => {
  const { user, loading } = useAuth();

  const scrollToHowToUse = () => {
    const element = document.getElementById("how-to-use");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Skip to main content link for accessibility */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      
      {/* Decorative background elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl animate-float" aria-hidden="true" />
      <div className="absolute bottom-40 left-10 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }} aria-hidden="true" />
      
      <Header />
      
      <main id="main-content" className="pt-16 sm:pt-20 md:pt-24 pb-12 sm:pb-16 px-2 sm:px-3 lg:px-4 relative z-10">
        <div className="container mx-auto max-w-[1400px] px-0">
          {/* Two Column Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-3 lg:gap-4">
            {/* Left Column - Hero/Saved Quizzes/Attempts */}
            <div className="space-y-4 sm:space-y-6 order-2 lg:order-1">
              {loading ? (
                <div className="animate-pulse space-y-4" aria-label="Loading content">
                  <div className="h-48 bg-muted rounded-xl" />
                  <div className="h-32 bg-muted rounded-xl" />
                </div>
              ) : user ? (
                <>
                  <section aria-labelledby="recent-quizzes-heading">
                    <h2 id="recent-quizzes-heading" className="text-xl sm:text-2xl font-bold text-foreground mb-3 sm:mb-4">
                      Recent Quizzes
                    </h2>
                    <SavedQuizzes />
                  </section>
                  <section aria-labelledby="attempt-history-heading">
                    <h2 id="attempt-history-heading" className="text-xl sm:text-2xl font-bold text-foreground mb-3 sm:mb-4">
                      Attempt History
                    </h2>
                    <AttemptHistory />
                  </section>
                </>
              ) : (
                <HeroSection />
              )}
            </div>

            {/* Right Column - Quiz Generator */}
            <section className="order-1 lg:order-2 mb-4 lg:mb-0" aria-label="Quiz Generator">
              <QuizGenerator onHowToUseClick={scrollToHowToUse} />
            </section>
          </div>
        </div>
      </main>

      {/* How to Use Section */}
      <HowToUseSection />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Index;
